import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, CardActions, Button, Divider, CardHeader, IconButton, Collapse } from '@material-ui/core';
import { getVeiculosOptions } from '../../store/veiculo/reducer';
import { findVeiculosOptions } from '../../store/veiculo/actions';
import { getRole } from '../../store/auth/reducer';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import moment from 'moment';
import DatePicker from '../DatePicker';
import UsuarioSelect from '../UsuarioSelect';
import DefaultSelect from '../DefaultSelect';
import SearchSelect from '../SearchSelect';
import ValidateSelect from '../ValidateSelect';
import TrueFalseSelect from '../TrueFalseSelect';
import MultiSelect from '../MultiSelect';
import Input from '../Input';
import clsx from 'clsx';
import * as Role from '../../constants/role';
import TipoEquipamentoSelect from '../TipoEquipamentoSelect';
import { getProdutoOptions } from 'store/produto/reducer';
import { loadProdutosOptions } from 'store/produto/actions';
import CartaoSelect from 'components/CartaoSelect';
import NumberInput from 'components/NumberInput';
import OptionSelect from 'components/OptionSelect';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    backgroundColor: theme.palette.bar.grayLight,
    overflow: 'inherit'
  },
  cardActions: {
    padding: theme.spacing(2)
  },
  actionsButtonContainer: {
    marginLeft: 'auto',
  },
  actionsButton: {
    marginRight: 10
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  cardHeader: {
    paddingTop: 10,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 0,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  divider: {
    backgroundColor: theme.palette.bar.grayMiddle
  },
  breakline: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
  }
}));

const defaultDates = useWeeklyDate => ({
  inicio: useWeeklyDate ? moment().startOf('week').valueOf() : moment().subtract(1, 'year').startOf('year').valueOf(),
  fim: moment().endOf('day').valueOf()
});

const DefaultFiltro = ({ onFilter, useDates, getDefaultDates, useInspetor, useInspetorMultiSelect, labelInspetor, useVeiculo, useColaborador, findVeiculosOptions, veiculosOptions,
  userRole, useTipoNota, useRole, useValidate, useWeeklyDate, useCodigo, codigoLabel, useNome, nomeLabel, useAtivo, useAtivoLabel, useCartao, useSisant,
  useTipoPagamento, disabledInspetorFilter, filterData, useCategoriaVeiculo, useTipoVeiculo, useCancelada, useTipoControleCaixa, useTipoDespesas, useTipoFormaPagamento,
  useControleCaixaStatus, mdInspetor, xsInspetor, mdCodigo, xsCodigo, mdNome, useNumSerieDrone, useGaragem, useTipoEquipamento, useNumSerie, useNumPatrimonio, useProduto, loadProdutosOptions, produtosOptions, useLocal, 
  useTipoUsuarioDocumento, usePossuiValidade, useValidade, usePossuiRastreador, useNumRastreador, useTipoPedido, useFornecedor, usePossuiCarteira, useSetor, 
  useTipoServico, useFolhaPontoStatus, useRegimeTrabalho, useNumFrota, useFinalidadeVeiculo, usePossuiCamera, useNumCamera}) => {

  const classes = useStyles();

  const [filter, setFilter] = useState(filterData || {});
  const [expanded, setExpanded] = useState(false);
  const [tipoDespesaOptions] = useState([
    { id: 'ALUGUEL_GARAGEM', nome: ' Aluguel de Garagem' },
    { id: 'ALUGUEL_VEICULOS', nome: ' Aluguel de Veículo' },
    { id: 'APORTE', nome: ' Aporte' },
    { id: 'CONDOMINIO', nome: ' Condominio' },
    { id: 'DARF', nome: ' Darf' },
    { id: 'ENERGIA_ELETRICA', nome: ' Energia Eletrica' },
    { id: 'FOLHA_PAGAMENTO', nome: ' Folha Pagamento' },
    { id: 'HONORARIOS_CONTABEIS', nome: ' Honorarios Contabeis' },
    { id: 'IMPOSTOS', nome: ' Impostos' },
    { id: 'INTERNET', nome: ' Internet' },
    { id: 'MANUTENCAO_DRONE', nome: ' Manutenção Drone' },
    { id: 'MANUTENCAO_VEICULO', nome: ' Manutenção Veículo' },
    { id: 'OUTROS', nome: ' Outros' },
    { id: 'PAGAMENTO_DIGITACAO', nome: ' Pagamento Digitação' },
    { id: 'PAGAMENTO_PRODUCAO', nome: ' Pagamento Produção' },
    { id: 'PLANO_SAUDE', nome: ' Plano de Saude' },
    { id: 'SEGURO_CONTRA_ACIDENTE', nome: ' Seguro Contra Acidente' },
    { id: 'TAXAS', nome: ' Taxas' }
  ]);

  useEffect(() => {
    if (useVeiculo || useTipoNota) findVeiculosOptions();
  }, [useVeiculo, useTipoNota, findVeiculosOptions]);

  useEffect(() => {
    if (useProduto) loadProdutosOptions();
  }, [useProduto, loadProdutosOptions]);

  useEffect(() => {
    if (!filterData && useDates && !filter.inicio) {
      setFilter({
        ...filter,
        ...(getDefaultDates != null ? getDefaultDates() : defaultDates(useWeeklyDate))
      });
    }
  }, [useDates, useWeeklyDate, filter]);

  const isAdmin = () => userRole === Role.ADMIN || userRole === Role.SUPER_ADMIN;

  return (
    <Card className={classes.root}>
      <CardHeader
        className={classes.cardHeader}
        title="Filtros"
        onClick={() => setExpanded(!expanded)}
        action={
          <IconButton
            disableRipple
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded,
            })}
            onClick={() => setExpanded(!expanded)}
          >
            <ExpandMoreIcon />
          </IconButton>
        }
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Grid container spacing={2}>
            {useDates && <>
              <Grid item md={2} xs={3}>
                <DatePicker
                  label="Data Início"
                  onChange={data => setFilter({
                    ...filter,
                    inicio: data.valueOf()
                  })}
                  value={filter.inicio}
                />
              </Grid>
              <Grid item md={2} xs={3}>
                <DatePicker
                  label="Data Fim"
                  onChange={data => setFilter({
                    ...filter,
                    fim: data.valueOf()
                  })}
                  value={filter.fim}
                />
              </Grid>
              <Grid className={classes.breakline} item xs={12} />
            </>}
            {useTipoEquipamento && <Grid item xs={3}>
              <TipoEquipamentoSelect
                showEmpty
                onChange={tipoEquipamento => setFilter({
                  ...filter,
                  tipoEquipamento,
                })}
                value={filter.tipoEquipamento}
              />
            </Grid>}
            {useTipoServico && <Grid item md={4} xs={6}>
              <OptionSelect
                label="Tipo de Serviços"
                codigo="TIPO_SERVICO"
                multiSelect
                onSelect={tipoServicos => setFilter({
                  ...filter,
                  tipoServicos,
                })}
                value={filter.tipoServicos}
                disabled={true}
              />
            </Grid>}
            {Role.INSPETOR !== userRole && Role.DIGITADOR !== userRole && Role.CROQUI !== userRole && useInspetor &&
              <Grid item md={mdInspetor || 2} xs={xsInspetor || 3}>
                <UsuarioSelect
                  label={labelInspetor}
                  onSelect={usuarioId => setFilter({
                    ...filter,
                    usuarioId
                  })}
                  grupos={[Role.ADMIN, Role.INSPETOR]}
                  value={filter.usuarioId}
                  disabled={disabledInspetorFilter}
                  multiSelect={useInspetorMultiSelect}
                />
              </Grid>}
            {useVeiculo && <Grid item md={2} xs={6}>
              <SearchSelect
                label="Veículo"
                multiSelect
                onSelect={veiculoId => setFilter({
                  ...filter,
                  veiculoId
                })}
                options={veiculosOptions ? veiculosOptions.map(v => ({ value: v.id, label: v.placa })) : []}
                value={filter.veiculoId}
              />
            </Grid>}
            {useTipoNota && <>
              <Grid item md={2} xs={3}>
                <DefaultSelect
                  label="Tipo Nota"
                  name="tipoNota"
                  showEmpty
                  options={[
                    { id: 'ALIMENTACAO', nome: 'Alimentação' },
                    { id: 'ABASTECIMENTO', nome: 'Abastecimento' },
                    { id: 'ADIANTAMENTO', nome: 'Adiantamento' },
                    { id: 'COMPRA_MANUTENCAO_VEICULAR', nome: 'Compra Man. Veicular' },
                    { id: 'CORREIO', nome: 'Correio' },
                    { id: 'HOSPEDAGEM', nome: 'Hospedagem' },
                    { id: 'MANUTENCAO_VEICULO', nome: 'Manutenção do Veículo' },
                    { id: 'OUTROS', nome: 'Outros' },
                    { id: 'PEDAGIO', nome: 'Pedágio/Balça' }
                  ]}
                  onSelect={e => setFilter({
                    ...filter,
                    tipoNota: e.target.value || null
                  })}
                  value={filter.tipoNota}
                />
              </Grid>
              <Grid item md={2} xs={3}>
                <SearchSelect
                  label="Veículos"
                  multiSelect
                  onSelect={veiculoIds => setFilter({
                    ...filter,
                    veiculoIds
                  })}
                  options={veiculosOptions ? veiculosOptions.map(v => ({ value: v.id, label: v.placa })) : []}
                  value={filter.veiculoIds}
                />
              </Grid>
            </>}
            {useTipoPagamento && <Grid item md={2} xs={3}>
              <DefaultSelect
                label="Tipo Pagamento"
                name="tipoPagamento"
                showEmpty
                options={[
                  { id: 'APORTE', nome: 'Aporte' },
                  { id: 'CARTAO_CORPORATIVO', nome: 'Cartão Corporativo' }
                ]}
                onSelect={e => setFilter({
                  ...filter,
                  tipoPagamento: e.target.value || null
                })}
                value={filter.tipoPagamento}
              />
            </Grid>}
            {useRole && <>
              <Grid item md={2} xs={3}>
                <DefaultSelect
                  label="Função"
                  name="role"
                  showEmpty
                  options={[
                    { id: 'ROLE_ADMIN', nome: 'Administrador' },
                    { id: 'ROLE_CROQUI', nome: 'Croqui' },
                    { id: 'ROLE_INSPETOR', nome: 'Inspetor' },
                    { id: 'ROLE_DIGITADOR', nome: 'Digitador' },
                  ]}
                  onSelect={e => setFilter({
                    ...filter,
                    role: e.target.value
                  })}
                  value={filter.role}
                />
              </Grid>
              {isAdmin() && <Grid item md={2} xs={3}>
                <TrueFalseSelect
                  label="Ativo"
                  onChange={event => setFilter({
                    ...filter,
                    usuarioAtivo: event.target.value || null
                  })}
                  value={filter.usuarioAtivo}
                />
              </Grid>}
              <Grid item md={2} xs={3}>
                <UsuarioSelect
                  grupos={filter.role ? [filter.role] : null}
                  onSelect={usuarioFuncaoId => setFilter({
                    ...filter,
                    usuarioFuncaoId
                  })}
                  value={filter.usuarioFuncaoId}
                  ativo={isAdmin() ? filter.usuarioAtivo : true}
                />
              </Grid>
            </>}
            {useValidate && <Grid item md={2} xs={3}>
              <ValidateSelect
                showEmpty
                onChange={validate => setFilter({
                  ...filter,
                  validate
                })}
                value={filter.validate}
              />
            </Grid>}
            {useCodigo && <Grid item md={mdCodigo || 2} xs={xsCodigo || 6}>
              <Input
                label={codigoLabel ? codigoLabel : 'Código'}
                onChange={event => setFilter({
                  ...filter,
                  codigo: event.target.value
                })}
                placeholder={codigoLabel ? codigoLabel : 'Código'}
                value={filter.codigo}
              />
            </Grid>}
            {useNumSerieDrone && <Grid item md={2} xs={3}>
              <Input
                label={'Série do drone'}
                onChange={event => setFilter({
                  ...filter,
                  numSerieDrone: event.target.value
                })}
                value={filter.numSerieDrone}
              />
            </Grid>}
            {useNome && <Grid item md={mdNome || 2} xs={12}>
              <Input
                label={nomeLabel ? nomeLabel : 'Nome'}
                onChange={event => setFilter({
                  ...filter,
                  nome: event.target.value
                })}
                placeholder={nomeLabel ? nomeLabel : 'Nome'}
                value={filter.nome}
              />
            </Grid>}
            {useCategoriaVeiculo && <Grid item md={2} xs={6}>
              <SearchSelect
                label="Categorias"
                multiSelect
                onSelect={categoriaVeiculos => setFilter({
                  ...filter,
                  categoriaVeiculos
                })}
                options={[
                  { value: 'BICICLETA_ELETRICA', label: 'Bicicleta Elétrica' },
                  { value: 'CARRO', label: 'Carro' },
                  { value: 'CAMINHAO', label: 'Caminhão' },
                  { value: 'UTILITARIO_CAMINHONETE', label: 'Caminhonete' },
                  { value: 'MAQUINA', label: 'Máquina' },
                  { value: 'MOTO', label: 'Moto' },
                  { value: 'REBOQUE', label: 'Reboque' },
                ]}
                value={filter.categoriaVeiculos}
              />
            </Grid>}
            {useTipoVeiculo && <Grid item md={2} xs={6}>
              <SearchSelect
                label="Proprietários"
                multiSelect
                onSelect={tipoVeiculos => setFilter({
                  ...filter,
                  tipoVeiculos
                })}
                options={[
                  { value: 'ELETROPONTES', label: 'Eletropontes' },
                  { value: 'PARTICULAR', label: 'Particular' },
                  { value: 'ALUGADO', label: 'Alugado' },
                ]}
                value={filter.tipoVeiculos}
              />
            </Grid>}
            {useFinalidadeVeiculo && <Grid item md={2} xs={6}>
              <OptionSelect
                label="Finalidades"
                codigo="VEICULO_FINALIDADES"
                multiSelect
                onSelect={finalidades => setFilter({
                  ...filter,
                  finalidades
                })}
                value={filter.finalidades}
              />
            </Grid>}
            {useTipoControleCaixa && <Grid item md={2} xs={6}>
              <DefaultSelect
                label="Tipo de Controle"
                showEmpty
                options={[
                  { id: 'DESPESA', nome: 'Despesa' },
                  { id: 'RECEITA', nome: 'Receita' },
                ]}
                onSelect={event => setFilter({
                  ...filter,
                  tipoControle: event.target.value || null
                })}
                value={filter.tipoControle}
              />
            </Grid>}
            {useCancelada && <Grid item md={2} xs={6}>
              <TrueFalseSelect
                label="Cancelada"
                onChange={event => setFilter({
                  ...filter,
                  cancelada: event.target.value || null
                })}
                value={filter.cancelada}
              />
            </Grid>}
            {useTipoFormaPagamento && <Grid item md={2} xs={6}>
              <DefaultSelect
                label="Forma Pagamento"
                showEmpty
                options={[
                  { id: 'BANCO', nome: 'Banco' },
                  { id: 'CAIXA', nome: 'Caixa' },
                ]}
                onSelect={event => setFilter({
                  ...filter,
                  formaPagamento: event.target.value || null
                })}
                value={filter.formaPagamento}
              />
            </Grid>}
            {useControleCaixaStatus && <Grid item md={2} xs={6}>
              <DefaultSelect
                label="Status"
                showEmpty
                options={[
                  { id: 'A_LIQUIDAR', nome: 'A Liquidar' },
                  { id: 'LIQUIDADO', nome: 'Liquidado' },
                  { id: 'CANCELADO', nome: 'Cancelado' }
                ]}
                onSelect={event => setFilter({
                  ...filter,
                  controleCaixaStatus: event.target.value || null
                })}
                value={filter.controleCaixaStatus}
              />
            </Grid>}
            {useTipoDespesas && <Grid item xs={12}>
              <MultiSelect
                label="Tipo Despesa"
                onChange={newValue => {
                  setFilter({
                    ...filter,
                    tipoDespesas: newValue ? newValue.map(v => v.value) : null
                  });
                }}
                defaultValue={tipoDespesaOptions && filter.tipoDespesas ? tipoDespesaOptions.filter(p => filter.tipoDespesas.indexOf(p.id) > -1).map(i => ({ value: i.id, label: i['nome'] })) : []}
                options={tipoDespesaOptions ? tipoDespesaOptions.map(i => ({ value: i.id, label: i['nome'] })) : []}
              />
            </Grid>}
            {useRegimeTrabalho && <Grid item xs={6}>
              <OptionSelect
                label="Regime de Trabalho"
                codigo="USUARIO_REGIME_TRABALHO"
                multiSelect
                onSelect={values => setFilter({
                  ...filter,
                  regimeTrabalhoIds: values
                })}
                value={filter.regimeTrabalhoIds}
              />
            </Grid>}
            {useFolhaPontoStatus && <Grid item xs={12}>
              <MultiSelect
                label="Status"
                onChange={values => setFilter({
                  ...filter,
                  folhaPontoStatus: values ? values.map(v => v.value) : []
                })}
                value={filter.folhaPontoStatus}
                options={[
                  {'value': 'CREATED', label: 'Criado'},
                  {'value': 'PROCESSING', label: 'Em Processamento'},
                  {'value': 'ERROR', label: 'Error'},
                  {'value': 'AVAILABLE', label: 'Disponível'},
                  {'value': 'RECEIVED', label: 'Recebido'},
                  {'value': 'VALIDATED', label: 'Validado'},
                  {'value': 'NOT_VALID', label: 'Inválido'},
                ]}
              />
            </Grid>}
            {useGaragem && <Grid item md={2} xs={6}>
              <TrueFalseSelect
                label="Está na Garagem"
                onChange={event => setFilter({
                  ...filter,
                  garagem: event.target.value || null
                })}
                value={filter.garagem}
              />
            </Grid>}
            {useAtivo && <Grid item md={2} xs={6}>
              <TrueFalseSelect
                label={useAtivoLabel || "Ativo"}
                onChange={event => setFilter({
                  ...filter,
                  ativo: event.target.value || null
                })}
                value={filter.ativo}
              />
            </Grid>}
            {useNumPatrimonio && <Grid item md={2} xs={3}>
              <Input
                label={'Num. Patrimônio'}
                onChange={event => setFilter({
                  ...filter,
                  numPatrimonio: event.target.value
                })}
                value={filter.numPatrimonio}
              />
            </Grid>}
            {useNumSerie && <Grid item md={2} xs={3}>
              <Input
                label={'Num. de Série'}
                onChange={event => setFilter({
                  ...filter,
                  numSerie: event.target.value
                })}
                value={filter.numSerie}
              />
            </Grid>}
            {useSisant && <Grid item md={2} xs={3}>
              <Input
                label={'Código SISANT'}
                onChange={event => setFilter({
                  ...filter,
                  codigoSisant: event.target.value
                })}
                value={filter.codigoSisant}
              />
            </Grid>}
            {useTipoPedido && <Grid item xs={4}>
              <DefaultSelect
                label="Tipo Nota"
                name="tipo"
                showEmpty
                options={[
                  { id: 'ENTRADA', nome: 'Entrada' },
                  { id: 'SAIDA', nome: 'Saida' },
                ]}
                onSelect={e => setFilter({
                  ...filter,
                  tipo: e.target.value || null
                })}
                value={filter.tipo}
              />
            </Grid>}
            {useLocal && <Grid item xs={4}>
              <DefaultSelect
                label="Local"
                showEmpty
                options={[
                  { id: 'Almoxarifado I  C17', nome: 'Almoxarifado I  C17 ' },
                  { id: 'Almoxarifado II  C17', nome: 'Almoxarifado II  C17' },
                  { id: 'Sala Drones', nome: 'Sala Drones' },
                  { id: 'Sucata', nome: 'Sucata' },
                ]}
                onSelect={event => {
                  setFilter({
                    ...filter,
                    local: event.target.value,
                  });
                }}
                value={filter.local}
              />
            </Grid>}
            {useColaborador && <Grid item xs={4}>
              <UsuarioSelect
                grupos={filter.role ? [filter.role] : null}
                onSelect={colaborador => setFilter({
                  ...filter,
                  colaborador
                })}
                label="Colaborador"
                value={filter.colaborador}
                ativo={isAdmin() ? filter.usuarioAtivo : true}
              />
            </Grid>}
            {useProduto && <Grid item xs={4}>
              <DefaultSelect
                label="Produto"
                showEmpty
                options={produtosOptions}
                onSelect={event => {
                  setFilter({
                    ...filter,
                    produto: event.target.value,
                  });
                }}
                value={filter.produto}
              />
            </Grid>}
            {useFornecedor && <Grid item xs={4}>
              <Input
                label="Fornecedor"
                onChange={event => setFilter({
                  ...filter,
                  fornecedor: event.target.value
                })}
                value={filter.fornecedor}
              />
            </Grid>}
            {usePossuiRastreador && <Grid item md={2} xs={6}>
              <TrueFalseSelect
                label="Possui Rastreador"
                onChange={event => setFilter({
                  ...filter,
                  possuiRastreador: event.target.value || null
                })}
                value={filter.possuiRastreador}
              />
            </Grid>}
            {useNumRastreador && <Grid item md={2} xs={3}>
              <Input
                label={'Num. Rastreador'}
                onChange={event => setFilter({
                  ...filter,
                  numRastreador: event.target.value
                })}
                value={filter.numRastreador}
              />
            </Grid>}
             {usePossuiCamera && <Grid item md={2} xs={6}>
              <TrueFalseSelect
                label="Possui Camera"
                onChange={event => setFilter({
                  ...filter,
                  possuiCamera: event.target.value || null
                })}
                value={filter.possuiCamera}
              />
            </Grid>}
            {useNumCamera && <Grid item md={2} xs={3}>
              <Input
                label={'Num. de Camera'}
                onChange={event => setFilter({
                  ...filter,
                  numCamera: event.target.value
                })}
                value={filter.numCamera}
              />
            </Grid>}
            {useNumFrota && <Grid item md={2} xs={3}>
              <Input
                label={'Num. de Frota'}
                onChange={event => setFilter({
                  ...filter,
                  numFrota: event.target.value
                })}
                value={filter.numFrota}
              />
            </Grid>}
            {useCartao && <Grid item md={2} xs={3}>
              <CartaoSelect
                onSelect={cartao => setFilter({
                  ...filter,
                  cartao
                })}
                label="Colaborador"
                value={filter.cartao}
              />
            </Grid>}
            {useTipoUsuarioDocumento &&<Grid item md={4}>
              <DefaultSelect
                label="Tipo"
                name="tipo"
                isRequired
                options={[
                  { id: 'DOCUMENTO', nome: 'Documento' },
                  { id: 'CERTIFICADO', nome: 'Certificado' },
                ]}
                onSelect={e => setFilter({
                  ...filter,
                  tipo: e.target.value || null
                })}
                value={filter.tipo}
              />
            </Grid>}
            {usePossuiValidade &&<Grid item md={4}>
              <TrueFalseSelect
                label="Possui Validade"
                name="possuiValidade"
                isRequired
                onChange={event => setFilter({
                  ...filter,
                  possuiValidade: event.target.value || null
                })}
                value={filter.possuiValidade}
              />
            </Grid>}
            {useValidade &&<Grid item md={4}>
              <NumberInput
                label="Validade (em anos)"
                onChange={valor => setFilter({
                  ...filter,
                  validadeEmAnos: valor
                })}
                value={filter.validadeEmAnos}
                decimalScale={0}
                prefix=""
                thousandSeparator=""
              />
            </Grid>}
            {useSetor &&<Grid item md={4}>
              <OptionSelect
                label="Setor"
                codigo="USUARIO_SETOR"
                onSelect={value => setFilter({
                  ...filter,
                  setorId: value
                })}
                value={filter.setorId}
              />
            </Grid>}
            {usePossuiCarteira &&<Grid item md={2}>
              <TrueFalseSelect
                label="Possui Carteira Assinada"
                name="possuiCarteira"
                onChange={event => setFilter({
                  ...filter,
                  possuiCarteira: event.target.value || null
                })}
                value={filter.possuiCarteira}
              />
            </Grid>}
          </Grid>
        </CardContent>
        <Divider className={classes.divider} />
        <CardActions className={classes.cardActions}>
          <Button
            disableRipple
            color="primary"
            size="small"
            variant="contained"
            onClick={() => {
              return onFilter(filter)
            }}
          >
            Filtrar
          </Button>
          <Button
            disableRipple
            color="primary"
            size="small"
            variant="contained"
            onClick={() => {
              setFilter({
                ...(getDefaultDates != null ? getDefaultDates() : defaultDates(useWeeklyDate))
              })
            }}
          >
            Limpar
          </Button>
        </CardActions>
      </Collapse>
    </Card>
  );
};

DefaultFiltro.defaultValue = {
  useDates: false,
  useInspetor: false,
  labelInspetor: "Inspetor",
  useVeiculo: false,
  useTipoNota: false,
  defaultValues: {},
  useRole: false,
  useValidate: false,
  useWeeklyDate: false,
  useCodigo: false,
  codigoLabel: 'Código',
  useNome: false,
  nomeLabel: 'Nome',
  useAtivo: false,
  useAtivoLabel: "Ativo",
  useTipoPagamento: false,
  disabledInspetorFilter: false,
  filterData: null,
  useCategoriaVeiculo: false,
  useTipoVeiculo: false,
  useCancelada: false,
  useTipoControleCaixa: false,
  useTipoDespesas: false,
  useTipoFormaPagamento: false,
  useControleCaixaStatus: false,
  useNumSerieDrone: false,
  useGaragem: false,
  useTipoEquipamento: false,
  useNumSerie: false,
  useNumPatrimonio: false,
  useProduto: false,
  useLocal: false,
  useColaborador: false,
  useCartao: false,
  useTipoUsuarioDocumento: false,
  usePossuiValidade: false,
  useValidade: false,
  usePossuiRastreador: false,
  useNumRastreador: false,
  usePossuiCamera: false,
  useNumCamera: false,
  useTipoPedido: false,
  useFornecedor: false,
  usePossuiCarteira: false,
  useSetor: false,
  useSisant: false,
  useInspetorMultiSelect: false,
  useTipoServico: false,
  useFinalidadeVeiculo: false,
}

const mapStateToProps = state => ({
  veiculosOptions: getVeiculosOptions(state),
  produtosOptions: getProdutoOptions(state),
  userRole: getRole(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  findVeiculosOptions,
  loadProdutosOptions,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DefaultFiltro);
